module.exports = __webpack_public_path__ + "05ebdbe10796850f045fcd484f35788d.woff";